class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.desktopQuery = window.matchMedia('(min-width: 990px)');
    this.closeDelay = 160;
    this.animationDelay = 280;

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.addEventListener('focusin', this.onFocusIn.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    this.setHeaderBottomPosition();
  }

  onSummaryClick(event) {
    if (!this.desktopQuery.matches || !this.isMegaMenu()) return;
    event.preventDefault();
    this.open();
  }

  onMouseEnter() {
    if (!this.desktopQuery.matches || !this.isMegaMenu()) return;
    this.open();
  }

  onMouseLeave() {
    if (!this.desktopQuery.matches || !this.isMegaMenu()) return;
    this.scheduleClose();
  }

  onFocusIn() {
    if (!this.desktopQuery.matches || !this.isMegaMenu()) return;
    this.open();
  }

  isMegaMenu() {
    return this.mainDetailsToggle.classList.contains('mega-menu');
  }

  open() {
    window.clearTimeout(this.closeTimer);
    window.clearTimeout(this.animationTimer);
    this.mainDetailsToggle.classList.remove('mega-menu--closing');

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close(true);
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);

    if (this.header) this.header.preventHide = true;
    this.setHeaderBottomPosition();
  }

  scheduleClose() {
    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(() => this.close(), this.closeDelay);
  }

  close(immediate = false) {
    window.clearTimeout(this.closeTimer);
    window.clearTimeout(this.animationTimer);
    this.summary.setAttribute('aria-expanded', false);

    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    if (immediate || !this.mainDetailsToggle.classList.contains('mega-menu')) {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.classList.remove('mega-menu--closing');
      if (this.header) this.header.preventHide = false;
      return;
    }

    this.mainDetailsToggle.classList.add('mega-menu--closing');
    this.animationTimer = window.setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.classList.remove('mega-menu--closing');
      if (this.header) this.header.preventHide = false;
    }, this.animationDelay);
  }

  setHeaderBottomPosition() {
    if (!this.header) return;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
